export default {
    latestVersionId: null
};
